import { render, staticRenderFns } from "./VerificationRuns.vue?vue&type=template&id=ddd726b2"
import script from "./VerificationRuns.vue?vue&type=script&lang=js"
export * from "./VerificationRuns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports